﻿const openDialogs: { [key: string]: DotNet.DotNetObject } = {};

function onDialogCancel(ev: Event) {
    const el = ev.currentTarget as HTMLDialogElement;
    if (!el) {
        return;
    }

    // Firefox happens to send a "cancel" event when an input file dialog is cancelled, so we need to catch that too.
    const target = ev.target as HTMLInputElement;
    if (target.tagName === "INPUT" && target.getAttribute("type")?.toLowerCase() === "file") {
        return;
    }

    const dotNetRef = openDialogs[el.id];
    if (!dotNetRef) {
        return;
    }

    // We only want to prevent default if we're actually delegating cancellation to Blazor-land.
    // The Blazor event callback can determine whether the dialog should actually close asynchronously.
    ev.preventDefault();
    dotNetRef.invokeMethodAsync("JS_OnDialogCancel");
}

function onDialogClose(ev: Event) {
    const el = ev.currentTarget as HTMLDialogElement;
    if (!el) {
        return;
    }

    const dotNetRef = openDialogs[el.id];
    if (!dotNetRef) {
        return;
    }

    // Close doesn't bubble and can't be prevented, so just tell Blazor we've closed.
    dotNetRef.invokeMethodAsync("JS_OnDialogClose");
}

export class DialogUtilities {
    openDialog(dialogID: string, dotNetRef: DotNet.DotNetObject) {
        const dlg = document.getElementById(dialogID) as HTMLDialogElement;

        if (!dlg) {
            throw Error(`Could not find a dialog with ID '${dialogID}'.`);
        }

        if (!dlg.showModal) {
            throw Error(`Could not open dialog with ID '${dialogID}'. It does not appear to be a <dialog> element.`);
        }

        if (dlg.hasAttribute("open")) {
            console.warn(`Dialog with ID '${dialogID}' is already open. Ignoring open request.`);
            return;
        }

        dlg.addEventListener("cancel", onDialogCancel);
        dlg.addEventListener("close", onDialogClose);
        openDialogs[dialogID] = dotNetRef;
        dlg.show();
    }

    closeDialog(dialogID: string) {
        const dlg = document.getElementById(dialogID) as HTMLDialogElement;

        if (!dlg) {
            throw Error(`Could not find a dialog with ID '${dialogID}'.`);
        }

        if (!dlg.close) {
            throw Error(`Could not close dialog with ID '${dialogID}'. It does not appear to be a <dialog> element.`);
        }

        dlg.removeEventListener("cancel", onDialogCancel);
        dlg.removeEventListener("close", onDialogClose);
        delete openDialogs[dialogID];

        if (dlg.hasAttribute("open")) {
            dlg.close();
        }
    }
}